import { Component } from "react";
export class ChunkBoundary extends Component {
    state = { hasError: false };
    static getDerivedStateFromError(error) {
        const isChunkError = error.name === "ChunkLoadError" ||
            error.message.includes("Loading chunk") ||
            error.message.includes("Failed to fetch dynamically imported module");
        if (isChunkError) {
            const alreadyRetried = sessionStorage.getItem("chunk_reload");
            if (!alreadyRetried) {
                sessionStorage.setItem("chunk_reload", "1");
                window.location.reload();
            }
        }
        return { hasError: true };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children && this.state.hasError) {
            sessionStorage.removeItem("chunk_reload");
            this.setState({ hasError: false });
        }
    }
    render() {
        if (this.state.hasError)
            return null;
        return this.props.children;
    }
}
